module.exports = __webpack_public_path__ + "media/images/dots-4585d3dcfdd10e2cda0bd3a9eba78d25.png";